var _defs, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSquareandpencil(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 2.657 30.571 30.527",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "sf-notes-square-and-pencil-cut0",
    maskUnits: "userSpaceOnUse",
    x: -100,
    y: -100,
    width: 300,
    height: 300
  }, /*#__PURE__*/React.createElement("rect", {
    x: -100,
    y: -100,
    width: 300,
    height: 300,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.191 25.508L14.805 23.945L31.797 6.914C33.223 5.508 33.223 3.242 31.797 1.816L31.367 1.387C29.961 0 27.715 0.059 26.289 1.465L9.336 18.437L7.715 21.875C6.699 24.023 8.965 26.445 11.191 25.508Z",
    fill: "#000"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#sf-notes-square-and-pencil-cut0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.484 33.183L20.996 33.183C25.156 33.183 27.48 30.879 27.48 26.699L27.48 12.207C27.48 8.027 25.156 5.723 20.996 5.723L6.484 5.723C2.324 5.723 0 8.027 0 12.207L0 26.699C0 30.879 2.324 33.183 6.484 33.183ZM2.832 26.699L2.832 12.207C2.832 9.863 4.141 8.535 6.484 8.535L20.996 8.535C23.34 8.535 24.648 9.863 24.648 12.207L24.648 26.699C24.648 29.043 23.34 30.371 20.996 30.371L6.484 30.371C4.141 30.371 2.832 29.043 2.832 26.699Z",
    fill: "currentColor"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.312 23.398L13.516 22.031L27.812 7.734L25.508 5.488L11.23 19.766L9.785 22.851C9.648 23.144 9.98 23.535 10.312 23.398ZM29.004 6.543L30.176 5.351C30.703 4.785 30.703 3.965 30.176 3.437L29.746 3.008C29.238 2.5 28.418 2.559 27.91 3.086L26.719 4.258Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareandpencil);
export default __webpack_public_path__ + "static/media/square.and.pencil.9d085c17775b0c2a804e3a4b7265edf5.svg";
export { ForwardRef as ReactComponent };